import './App.css';
import { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import marketHome from './utils/marketHome.png';
import marketProducts from './utils/marketProducts.png';
import curation from './utils/curation.png';
import curationList from './utils/curationList.png';
import headshot from './utils/headshot.jpg';
import unl from './utils/unl-logo.webp';

const EMAILJS_SERVICE_ID  = 'service_ijzor6j';  
const EMAILJS_TEMPLATE_ID = 'template_josg2sn';
const EMAILJS_PUBLIC_KEY  = 'BvqfLIJ_V5SdnLTDF';

function App() {
  const form = useRef();
  const [status, setStatus] = useState(null); // null | 'sending' | 'success' | 'error'

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus('sending');

    emailjs
      .sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, form.current, {
        publicKey: EMAILJS_PUBLIC_KEY,
      })
      .then(() => {
        setStatus('success');
        form.current.reset();
        setTimeout(() => setStatus(null), 5000);
      })
      .catch(() => {
        setStatus('error');
        setTimeout(() => setStatus(null), 5000);
      });
  };

  return (
    <div className="App">

      {/* ── INTRO ── */}
      <header className="App-header">
        <h1><strong>Kyle Wydrinski</strong></h1>
        <p className="subtitle">Software Engineer · Full-Stack Developer</p>
        <div className="scroll-hint">Scroll to explore</div>
      </header>

      {/* ── MY WORK ── */}
      <div className="Portfolio">
        <h1>Selected Work</h1>

        <div className="Card">
          <img src={marketHome} alt="Market – home screen" />
          <img src={marketProducts} alt="Market – products screen" />
          <div className="Container">
            <h4 data-tag="Research Platform">Market</h4>
            <p>
              Sponsored by the University of Nebraska-Lincoln's Department of Agricultural
              Economics, this Open Access Online Experimental Retail Facility lets researchers
              build fully customizable experiments — configurable popups, dynamic product
              catalogs, and simultaneous multi-experiment support. As the team's backend
              developer I designed and built the REST API layer that ties it all together.
            </p>
            <div className="tech-tags">
              {['React', 'Node.js', 'MySQL', 'REST API'].map(t => (
                <span className="tech-tag" key={t}>{t}</span>
              ))}
            </div>
          </div>
        </div>

        <div className="Card">
          <img src={curation} alt="Curation – discover view" />
          <img src={curationList} alt="Curation – playlist view" />
          <div className="Container">
            <h4 data-tag="Full-Stack App">Curation</h4>
            <p>
              A music discovery platform where users explore new tracks, curate playlists,
              and share favorites with a community. Backed by PostgreSQL via Prisma for
              type-safe queries, secured with OAuth, styled with Tailwind CSS, and kept
              live across devices through WebSocket real-time sync.
            </p>
            <div className="tech-tags">
              {['Next.js', 'React', 'PostgreSQL', 'Prisma', 'Tailwind CSS', 'WebSockets', 'OAuth'].map(t => (
                <span className="tech-tag" key={t}>{t}</span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── EDUCATION ── */}
      <div className="Education">
        <h1>Education</h1>

        <div className="Card-2">
          <img src={unl} alt="UNL School of Computing" />
          <div className="Container">
            <h4 data-tag="B.S. Computer Science">University of Nebraska – Lincoln</h4>
            <div className="degree-info">
              Major: Computer Science<br />
              Minor: Mathematics<br />
              May 2026 Graduate
            </div>
            <p>Relevant Coursework</p>
            <div className="course-list">
              {[
                'Fundamentals of Cybersecurity',
                'Operating Systems Principles',
                'Secure Software Engineering',
                'Computer Systems Engineering',
                'Communication Networks',
                'Principles of Operations Research',
                'Automata, Computation & Formal Languages',
                'Program Language Concepts',
                'Unix Programming',
              ].map(c => (
                <span className="course-pill" key={c}>{c}</span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── CONTACT ── */}
      <div className="Education">
        <h1>Contact Me</h1>

        <div className="Card-2">
          <img src={headshot} alt="Kyle Wydrinski" />
          <div className="Container">
            <h4 data-tag="kylewydrinski@gmail.com">Let's Make Something</h4>

            <form ref={form} className="contact-form" onSubmit={sendEmail}>
              <div className="field-group">
                <label className="field-label" htmlFor="user_name">Name</label>
                <input
                  id="user_name"
                  className="textbox"
                  name="user_name"
                  type="text"
                  placeholder="Jane Smith"
                  required
                />
              </div>

              <div className="field-group">
                <label className="field-label" htmlFor="user_email">Email</label>
                <input
                  id="user_email"
                  className="textbox"
                  name="user_email"
                  type="email"
                  placeholder="jane@example.com"
                  required
                />
              </div>

              <div className="field-group">
                <label className="field-label" htmlFor="message">Message</label>
                <textarea
                  id="message"
                  className="textbox"
                  name="message"
                  placeholder="Tell me about your project..."
                  required
                />
              </div>

              <button
                className="contact-btn"
                type="submit"
                disabled={status === 'sending'}
              >
                <span>
                  {status === 'sending' ? 'Sending...' : 'Send Message'}
                </span>
              </button>

              {status === 'success' && (
                <p className="form-status success">
                  ✓ &nbsp;Message sent — I'll be in touch soon.
                </p>
              )}
              {status === 'error' && (
                <p className="form-status error">
                  ✕ &nbsp;Something went wrong. Try emailing me directly.
                </p>
              )}
            </form>
          </div>
        </div>
      </div>

      <footer className="App-footer">
        © {new Date().getFullYear()} Kyle Wydrinski
      </footer>

    </div>
  );
}

export default App;